<template>
  <div fluid class="full-screen-background">
    <v-container>
      <v-row>
        <v-col>
          <div style="padding: 30px 40px 30px 10px;">
            <p>WE PROVIDE</p>
            <h1>
              EXPERT <span style="color:#03A9F4;">SOLUTIONS, </span>
            </h1>
            <h1 style="text-indent: 2em;">
              EXCEPTIONAL <span style="color:#03A9F4;">SERVICE</span>
            </h1>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
</script>

<style scoped>
p {
  font-size: 30px;
  color: #01579B;
}

h1 {
  font-size: 3rem;
  font-weight: bold;
  color: silver;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
}

.full-screen-background {
  background-image: url('/public/assets/img/GGI1_h6o94nh6o94nh6o9.png');
  background-size: cover;
  background-position: center;
  background-color: #f8f9fa;
  background-repeat: no-repeat;
  background-attachment: fixed;
  height: calc(100vh - 104px);
  width: 100vw;
  padding: 0;
  margin: 0;
}
</style>